import PolicyLayout, { Section } from "@/components/site/PolicyLayout";
import usePageMeta from "@/hooks/usePageMeta";

export default function Terms() {
  usePageMeta({
    title: "Terms of Use | RUDRA EMPIRE",
    description:
      "Terms of Use — the terms that govern your access to www.rudraempire.com and the materials, information and portal made available through it.",
    canonical: "https://rudraempire.com/terms",
  });
  return (
    <PolicyLayout
      eyebrow="Policy · II"
      title="Terms"
      italic="of Use."
      lastUpdated="August 2026"
    >
      <p className="text-lg text-neutral-200 italic">
        The following terms govern your access to www.rudraempire.com and the
        materials, information and portal made available through it.
      </p>

      <Section number="01" title="Acceptance">
        <p>
          By accessing or using this website, you agree to be bound by these Terms. If you do not accept them, please do not use the site.
        </p>
      </Section>

      <Section number="02" title="Nature of the Website">
        <p>
          This website is a corporate portfolio for RUDRA EMPIRE. It is <span className="text-neutral-100">informational</span> in nature. Nothing on this website constitutes an offer to sell, buy, lease, or transfer any land or interest in land. Any transaction requires a separately executed, written agreement between the parties.
        </p>
      </Section>

      <Section number="03" title="Intellectual Property">
        <p>
          All content on this website — including but not limited to text, photographs, illustrations, logos, marks, layouts, code, and the "RUDRA EMPIRE" wordmark — is the property of RUDRA EMPIRE (or licensed to it) and is protected by applicable Indian and international intellectual-property laws. You may not reproduce, distribute, modify, publicly display, or create derivative works from any material on this site without our prior written consent.
        </p>
      </Section>

      <Section number="04" title="Permitted Use">
        <p>
          You may view and read the content for lawful, personal, non-commercial purposes. You may not:
        </p>
        <ul className="list-none space-y-3 mt-3">
          <li className="flex gap-3"><span className="text-[#D4AF37]">—</span> attempt to gain unauthorised access to the Employee Portal or any restricted area;</li>
          <li className="flex gap-3"><span className="text-[#D4AF37]">—</span> scrape, mirror or systematically download the site;</li>
          <li className="flex gap-3"><span className="text-[#D4AF37]">—</span> introduce any malware, exploit, or automated abuse; or</li>
          <li className="flex gap-3"><span className="text-[#D4AF37]">—</span> misrepresent your identity, affiliation, or communications through the enquiry form.</li>
        </ul>
      </Section>

      <Section number="05" title="Employee Portal">
        <p>
          Access to the Employee Portal is invitation-only and granted at the sole discretion of RUDRA EMPIRE's administrator. Portal users are personally accountable for their credentials and for all activity performed under their account. Sharing credentials, granting third-party access, or using the portal outside the scope of your engagement is prohibited and grounds for immediate revocation.
        </p>
      </Section>

      <Section number="06" title="External Links">
        <p>
          The website may occasionally reference or link to third-party resources. RUDRA EMPIRE does not endorse and is not responsible for the content, availability, or practices of any external site.
        </p>
      </Section>

      <Section number="07" title="Disclaimer of Warranties">
        <p>
          The website is provided on an "as is" and "as available" basis. To the fullest extent permitted by law, RUDRA EMPIRE disclaims all warranties, express or implied, including any warranty of merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that the site will always be available, error-free, or up-to-date.
        </p>
      </Section>

      <Section number="08" title="Limitation of Liability">
        <p>
          To the fullest extent permitted by law, RUDRA EMPIRE shall not be liable for any indirect, incidental, consequential, or punitive damages arising from or in connection with your use of the website. Nothing in these Terms excludes liability that cannot be excluded under applicable law.
        </p>
      </Section>

      <Section number="09" title="Governing Law & Jurisdiction">
        <p>
          These Terms are governed by the laws of the Republic of India. Any dispute arising out of or in connection with the website shall be subject to the exclusive jurisdiction of the competent courts in Bengaluru, Karnataka.
        </p>
      </Section>

      <Section number="10" title="Changes">
        <p>
          We may amend these Terms at any time; the revised version will apply from the date it is posted on this page.
        </p>
      </Section>
    </PolicyLayout>
  );
}
